import {
  FaWhatsapp,
  FaInstagram,
  FaYoutube,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaSolarPanel,
  FaBolt,
  FaTools,
  FaLeaf,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "./assets/logo.png";

function Footer() {
  const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
};
  return (
    <footer className="footer">
      <div className="footer-glow footer-glow-one"></div>
      <div className="footer-glow footer-glow-two"></div>

      <div className="footer-container">
        <div className="footer-brand footer-section">
          <img src={logo} alt="Solar Wave Logo" className="footer-logo" />
          <p>
            Powering your future with clean, affordable, and sustainable solar
            energy solutions for homes, businesses, and industries.
          </p>

          <div className="footer-highlights">
            <span><FaSolarPanel /> Solar Experts</span>
            <span><FaLeaf /> Clean Energy</span>
          </div>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
         <ul>
  <li>
    <Link to="/" onClick={scrollToTop}>Home</Link>
  </li>
  <li>
    <Link to="/about" onClick={scrollToTop}>About</Link>
  </li>
  <li>
    <Link to="/products" onClick={scrollToTop}>Products</Link>
  </li>
  <li>
    <Link to="/contact" onClick={scrollToTop}>Contact</Link>
  </li>
</ul>
        </div>

        <div className="footer-section">
          <h3>Products</h3>
          <ul>
            <li><FaSolarPanel /> On-Grid Solar</li>
            <li><FaBolt /> Off-Grid Solar</li>
            <li><FaLeaf /> Hybrid System</li>
            <li><FaTools /> Maintenance</li>
          </ul>
        </div>

        <div className="footer-section contact-section">
          <h3>Contact</h3>
          <p><FaMapMarkerAlt /> Jhansi, Uttar Pradesh (India)</p>
          <p><FaPhoneAlt /> +91 8953395689</p>
          <p><FaEnvelope /> solarwavetechnology@gmail.com</p>
        </div>
      </div>

      <div className="footer-social">
        <a
          href="https://wa.me/918953395689"
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp"
        >
          <FaWhatsapp />
        </a>
        <a href="#" aria-label="Instagram">
          <FaInstagram />
        </a>
        <a href="#" aria-label="YouTube">
          <FaYoutube />
        </a>
      </div>

      <div className="footer-bottom">
        <p>© 2026 Solar Wave Technology | All Rights Reserved</p>
      </div>
    </footer>
  );
}

export default Footer;